import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/ui/flashlight.scss'

const Flashlight = () => {

    const location = useLocation();
    const [atTop, setAtTop] = useState(true)

    useEffect(()=>{
        location.pathname === '/' ? setAtTop(false) : setAtTop(true)
    },[location])


    return (
        atTop && <div className="flashlight-container">
            
        </div>
    )
}

export default Flashlight;